import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import Gallery from 'react-grid-gallery';
import useReactRouter from 'use-react-router';
import InfiniteScroll from 'react-infinite-scroll-component';
import shopOnSheroesService from '../services/shopOnSheroesService';
import NoMedia from '../components/common/noMedia';

const ShopMedia = ({ qs, streamSearchUrl }) => {
  const classes = useStyles();
  const [images, setImages] = useState([]);
  const { history } = useReactRouter();
  const [token, setNextToken] = useState('');
  const [dataLength, setDataLength] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  useEffect(() => {
    async function getMedia() {
      const res = await shopOnSheroesService.getShopMedia(
        streamSearchUrl,
        '',
        qs
      );
      setImages(res);
      setHasMore(res && res.length > 0 ? true : false);
      setNextToken(res.nextToken);
    }
    getMedia();
  }, [qs, streamSearchUrl]);

  async function fetchData() {
    const res = await fetchMedia();
    images ? setImages([...images, ...res]) : setImages([...res]);
    setHasMore(res.length > 0 ? true : false);
    setNextToken(res.nextToken);
    const totalLength = parseInt(dataLength) + parseInt(res.length);
    setDataLength(totalLength);
  }

  async function fetchMedia() {
    const response = await shopOnSheroesService.getShopMedia(
      streamSearchUrl,
      token,
      qs
    );
    return response;
  }

  const handleOnClick = (e) => {
    const index = e;
    const selectedImg = images.filter((image, i) => i === index);
    selectedImg && history.push(selectedImg[0].url);
  };
  return (
    <React.Fragment>
      <div
        style={{
          display: 'block',
          minHeight: '1px',
          width: '100%',
          // border: '1px solid #ddd',
          overflow: 'auto',
        }}
      >
        {images.length === 0 ? (
          <NoMedia />
        ) : (
          <InfiniteScroll
            dataLength={dataLength} //This is important field to render the next data
            next={fetchData}
            hasMore={hasMore}
            className={classes.root}
          >
            <Gallery
              images={images}
              enableLightbox={false}
              enableImageSelection={false}
              onClickThumbnail={(e) => handleOnClick(e)}
            />
          </InfiniteScroll>
        )}
      </div>
    </React.Fragment>
  );
};

const useStyles = makeStyles((theme) => ({
  imageSize: {
    width: '100px',
    height: '150px',
  },
}));
export default ShopMedia;
